import { SignalrConnection, IHubProxy } from './signalr-helpers';


export interface IGamePlanLoggingHub {
    information(sharedSecret: string, msgTemplate: string, args: any[], extraProperties: any): JQueryDeferred<any>;
}

export class GamePlanLoggingHub implements IGamePlanLoggingHub {
    proxy: IHubProxy;
    constructor(connection: SignalrConnection) {
        this.proxy = connection.connection.createHubProxy('gamePlanLoggingHub')
    }

    information(sharedSecret: string, msgTemplate: string, args: any[], extraProperties: any) {
        return this.proxy.invoke("Information", sharedSecret, msgTemplate, args, extraProperties);
    }

}


